module.exports = __webpack_public_path__ + "img/ZM.0d74edfd.svg";